import React from 'react'

import HoverTooltip from '../../../../../components/HoverTooltip'

import Section from '../../../../../components/Section'
import { Contract, ContractPosition } from '../../types'
import { CurrencyList } from '../types'
import ContractTable from './ContractBaseInfoTab/Table/ContractTable'

type Props = {
    theme: string
    contract: Contract
    isActive: boolean
    currencyList: CurrencyList[]
    dataReloadToken: number
    contractYear: number | null
}

const ContractBaseInfoTab: React.FC<Props> = (props) => {
    return (
        <Section title="Информация о договоре">
            <div className="flex flex-col w-full gap-x-5 ">
                <ContractTable
                    theme={props.theme}
                    contractGuid={props.contract.guid}
                    contractRegNumber={props.contract.contract_reg_number}
                    isActive={props.isActive}
                    currencyList={props.currencyList}
                    contractPrice={props.contract.price}
                    contractRubPrice={props.contract.rub_price}
                    dataReloadToken={props.dataReloadToken}
                    contractVersion={props.contract.version}
                    contractYear={props.contractYear}
                    contractStage={props.contract.contract_stage}
                />
            </div>
        </Section>
    )
}

export default ContractBaseInfoTab
